import $ from "jquery";
export function accordion() {
  /* Accordion Begin */

  $(".accordion-item__title-wrapper").click(function (e) {
    e.preventDefault();
    var parent = $(this).parent(".accordion-item");

    if (parent.hasClass("accordion-item--active")) {
      $(this).next().slideUp();
      parent.removeClass("accordion-item--active");
    } else {
      $(".accordion-item").removeClass("accordion-item--active");
      parent.toggleClass("accordion-item--active");
      $(".accordion-item__text").slideUp();
      $(this).next().slideDown();
    }
  });

  /* Accordion End */
}

export function solutionsAccordion() {
  /* Accordion Begin */

  if ($(".solution-subcategory-item--lonely").length > 0) {
    //trigger click on lonely accordion item
    //$(".solution-subcategory-item__title-wrapper").trigger("click");

    var parent = $(".solution-subcategory-item");
    $(".accordion-item").removeClass("solution-subcategory-item--active");
    parent.toggleClass("solution-subcategory-item--active");
    $(".solution-subcategory-item__text-content").slideDown();
  }

  $(".solution-subcategory-item__title-wrapper").click(function (e) {
    e.preventDefault();
    var parent = $(this).parent(".solution-subcategory-item");

    if (parent.hasClass("solution-subcategory-item--active")) {
      $(this).next().slideUp();
      parent.removeClass("solution-subcategory-item--active");
    } else {
      $(".accordion-item").removeClass("solution-subcategory-item--active");
      parent.toggleClass("solution-subcategory-item--active");
      $(this).next().slideDown();
    }
  });

  /* Accordion End */
}
